import React from "react";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Box from "@mui/material/Box";
import OrderActions from "./OrderActions";
import { styled } from "@mui/material/styles";
import { UserData } from "types/models/master/MasterApp";

const COLUMN_WIDTH = 200; 

const StyledTableCell = styled(TableCell)(() => ({
  fontSize: 14,
  padding: 8,
  width: COLUMN_WIDTH,
  maxWidth: 180,
  minWidth: 160,
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
}));

interface TableItemProps {
  data: UserData;
  roleName: string;
}

const TableItem: React.FC<TableItemProps> = ({ data, roleName }) => {
  const getStatusColor = (isActive: boolean) => {
    return isActive ? "#43C888" : "#F84E4E";
  };

  return (
    <TableRow key={data.username} className="item-hover">
      <StyledTableCell align="left">
        <OrderActions data={data} />
      </StyledTableCell>

      <StyledTableCell align="left">{data.name}</StyledTableCell>

      <StyledTableCell align="left">{data.username}</StyledTableCell>

      <StyledTableCell align="left">{roleName}</StyledTableCell>

      <StyledTableCell align="left">{data.contactNo}</StyledTableCell>

      <StyledTableCell align="left">{data.email}</StyledTableCell>

      <StyledTableCell align="left">{data.SRCode}</StyledTableCell>

      <StyledTableCell align="left">
        <Box
          sx={{
            color: getStatusColor(data.IsActive),
            backgroundColor: getStatusColor(data.IsActive) + "44",
            padding: "3px 5px",
            borderRadius: 1,
            fontSize: 14,
            display: "inline-block",
            minWidth: 80,
            textAlign: "center",
          }}
        >
          {data.IsActive ? "Active" : "Inactive"}
        </Box>
      </StyledTableCell>
    </TableRow>
  );
};

export default TableItem;
